export const TECH_INITIAL_STATE = {
    filter: {
        name: '',
        show: 'active',
    },
    createTechInitial: {
        name: '',
        active: true,
        feedLotId: '',
    },
    loader: true,
};
